var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',{staticClass:"to-title"},[_c('span',{staticClass:"to-title__title primary--text"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('span',{staticClass:"to-title__subtitle"},[_vm._v("» "+_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }